import { createAction } from 'redux-actions';
import { SET_POLICY_NAME } from './actionTypes';

const setPolicyName = createAction(SET_POLICY_NAME);

// eslint-disable-next-line import/prefer-default-export
export { setPolicyName };
